var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ItemTableActionBarHeaderMessage',{attrs:{"level":"error","linkText":"view","message":"- Invalid Service Accounts","messageHeader":"MacOS Issues"}},[_c('ButtonLink',{attrs:{"data-test-id":"SecureTokenRemediationBanner_link","text":"view"},on:{"click":function($event){return _vm.handleClick()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }